export function isStandalone(): boolean {
  try {
    return (
      matchMedia("(display-mode: standalone)").matches ||
      matchMedia("(display-mode: fullscreen)").matches ||
      (navigator as { standalone?: boolean }).standalone === true
    );
  } catch {
    return false;
  }
}

// iPadOS reports itself as MacIntel — maxTouchPoints is what distinguishes a
// touch Mac (an iPad) from a real desktop Mac.
export function isIos(): boolean {
  try {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return true;
    return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  } catch {
    return false;
  }
}

// These webviews cannot add to the home screen at all, so the banner must
// stay hidden there rather than give instructions that don't work.
export function isUnsupportedInAppBrowser(): boolean {
  try {
    return /FBAN|FBAV|Instagram|LinkedInApp|Line|Twitter/.test(navigator.userAgent);
  } catch {
    return false;
  }
}

export function isMobile(): boolean {
  try {
    return matchMedia("(pointer: coarse)").matches;
  } catch {
    return false;
  }
}

export function displayMode(): "standalone" | "browser" | "minimal-ui" | "fullscreen" {
  try {
    if (matchMedia("(display-mode: standalone)").matches) return "standalone";
    if (matchMedia("(display-mode: fullscreen)").matches) return "fullscreen";
    if (matchMedia("(display-mode: minimal-ui)").matches) return "minimal-ui";
    if ((navigator as { standalone?: boolean }).standalone === true) return "standalone";
  } catch {
    // fall through
  }
  return "browser";
}

export function installPlatform(): "ios" | "android" | "other" {
  if (isIos()) return "ios";
  try {
    if (/Android/.test(navigator.userAgent)) return "android";
  } catch {
    // fall through
  }
  return "other";
}
